import React from 'react';

// Определяем пути к изображениям
const freshFishImg = new URL('./images/categories/fresh_fish.png', import.meta.url).href;
const cannedProductsImg = new URL('./images/categories/canned_products.png', import.meta.url).href;
const saltedSmokedFishImg = new URL('./images/categories/salted_smoked_fish.png', import.meta.url).href;
const redCaviarImg = new URL('./images/categories/red_caviar.png', import.meta.url).href;
const shrimpsLangoustinesImg = new URL('./images/categories/shrimps_langoustines.png', import.meta.url).href;
const mollusksImg = new URL('./images/categories/mollusks.png', import.meta.url).href;
const fishLogoImg = new URL('./assets/icons/fish-logo.png', import.meta.url).href;

// Компонент для отображения иконки категории
// Использует изображения для некоторых категорий и эмодзи для остальных
const CategoryIcon = ({ category, size = 'medium', className = '' }) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  
  // Размеры иконок
  const sizes = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
    xlarge: 'w-16 h-16'
  };

  // Размеры текста для эмодзи
  const textSizes = {
    small: 'text-lg',
    medium: 'text-2xl',
    large: 'text-3xl',
    xlarge: 'text-4xl'
  };

  // Категории с кастомными изображениями
  const customImages = {
    'fresh_fish': freshFishImg,
    'canned_products': cannedProductsImg, 
    'salted_smoked_fish': saltedSmokedFishImg,
    'red_caviar': redCaviarImg,
    'shrimps_langoustines': shrimpsLangoustinesImg,
    'shrimp': shrimpsLangoustinesImg, // старое название категории
    'mollusks': mollusksImg,
    'shellfish': mollusksImg // альтернативное название
  };

  // Эмодзи для категорий без изображений (резервный вариант)
  const emojis = {
    'other': '🐙',
    'seafood': '🦞',
  };

  // Fallback-изображение (фирменная рыбка)
  const fallbackImage = fishLogoImg;

  // Если есть кастомное изображение
  if (customImages[category]) {
    return (
      <div className={`${sizes[size]} flex items-center justify-center ${className} relative`}>
        {!imageLoaded && (
          <img src={fallbackImage} alt="" className={`${sizes[size]} object-contain absolute`} />
        )}
        <img
          src={customImages[category]}
          alt={category}
          className={`w-full h-full object-contain transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
          loading="lazy"
          onLoad={() => setImageLoaded(true)}
        />
      </div>
    );
  }

  // Для категорий с эмодзи — показываем эмодзи
  if (emojis[category]) {
    return (
      <span className={`${textSizes[size]} ${className}`}>
        {emojis[category]}
      </span>
    );
  }

  // Для остальных — фирменная рыбка
  return (
    <div className={`${sizes[size]} flex items-center justify-center ${className}`}>
      <img src={fallbackImage} alt="Рыба" className="w-full h-full object-contain" />
    </div>
  );
};

export default CategoryIcon;